import React from "react";

import type { ErrorBoundaryContextType } from "./types";

export const ErrorBoundaryContext = React.createContext<ErrorBoundaryContextType | undefined>(undefined);
